import {css} from "styled-components"

/** @author: Richard 16th May 2018
 *  @desc: Not written by me, I used http://www.cssportal.com/css-ribbon-generator/
 */

export default css`
  position: absolute;
  left: -5px;
  top: -5px;
  z-index: 3;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;

  span {
    font-size: 10px;
    font-weight: bold;
    color: ${({theme}) => theme.colors.greys.white};
    text-transform: uppercase;
    text-align: center;
    line-height: 20px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    width: 100px;
    display: block;
    background: ${({theme}) => theme.colors.brand.default};
    box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
    position: absolute;
    top: 19px;
    left: -21px;

    &:before {
      content: "";
      position: absolute;
      left: 0px;
      top: 100%;
      z-index: -1;
      border-left: 3px solid ${({theme}) => theme.colors.brand.shade};
      border-right: 3px solid transparent;
      border-bottom: 3px solid transparent;
      border-top: 3px solid ${({theme}) => theme.colors.brand.shade};
    }

    &:after {
      content: "";
      position: absolute;
      right: 0px;
      top: 100%;
      z-index: -1;
      border-left: 3px solid transparent;
      border-right: 3px solid ${({theme}) => theme.colors.brand.shade};
      border-bottom: 3px solid transparent;
      border-top: 3px solid ${({theme}) => theme.colors.brand.shade};
    }
  }
`
